import React from 'react';

import styles from './GameLoading.scss';
import Button from 'Components/Button';
import LoadingFacts from './LoadingFacts';
import Preloader from './Preloader';
import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';
import apps from 'Settings/apps';
import appStoreBadge from 'Static/images/badges/app-store-badge.svg';
import microsoftBadge from 'Static/images/badges/microsoft-badge.svg';
import googlePlayBadge from 'Static/images/badges/google-play-badge.png';

class GameLoading extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      preloaderVisible: true,
    };

    this.preloaderTimeout = null;
  }

  componentDidMount() {
    this.preloaderTimeout = window.setTimeout(
      () => this.setState({ preloaderVisible: false }),
      4000
    );
  }

  componentWillUnmount() {
    window.clearTimeout(this.preloaderTimeout);
  }

  render() {
    const {
      gameLoaded,
      loadingProgress,
      gameLoadingError,
      gameLoadingErrorMessageId,
      slug,
      seriesNumber,
      handleReload,
      showAppLinks,
    } = this.props;

    const { appLinks, title } = apps[slug];
    const { appStoreLink, googlePlayLink, microsoftLink } = appLinks || {};
    const { preloaderVisible } = this.state;

    if (!gameLoaded) {
      const adjustedPercent = Math.floor(((loadingProgress * 100) / 88) * 100);
      const percentLoaded = adjustedPercent > 100 ? 100 : adjustedPercent;

      const getLoadingMessage = () => {
        if (gameLoadingErrorMessageId)
          return (
            <div>
              <ConnectedFormattedMessage id={gameLoadingErrorMessageId} />
              {showAppLinks && (
                <div>
                  <p>Or, download {title} for your mobile device.</p>
                  <div className="GameLoading__app-store-links">
                    {appStoreLink && (
                      <div>
                        <a href={appStoreLink}>
                          <img src={appStoreBadge} />
                        </a>
                      </div>
                    )}
                    {googlePlayLink && (
                      <div>
                        <a href={googlePlayLink}>
                          <img src={googlePlayBadge} />
                        </a>
                      </div>
                    )}
                    {microsoftLink && (
                      <div>
                        <a href={microsoftLink}>
                          <img src={microsoftBadge} />
                        </a>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          );
        if (gameLoadingError)
          return <ConnectedFormattedMessage id="errors.model_generic_load" />;
        if (percentLoaded === 0)
          return <ConnectedFormattedMessage id="game_loading.loading_label" />;
        if (percentLoaded >= 100)
          return (
            <ConnectedFormattedMessage id="game_loading.launching_label" />
          );
        return percentLoaded + '%';
      };
      return (
        <div
          className={`GameLoading GameLoading--${slug} ${
            gameLoadingError ? 'GameLoading--error' : ''
          }`}
        >
          {preloaderVisible ? (
            <Preloader
              slug={slug}
              seriesNumber={seriesNumber}
              title={<ConnectedFormattedMessage id={`model.${slug}.title`} />}
            />
          ) : null}
          {!gameLoadingError ? (
            <LoadingFacts slug={slug} okayToRefresh={percentLoaded < 100} />
          ) : (
            <div className="GameLoading__error-title">
              <ConnectedFormattedMessage id="game_loading.error_title" />
            </div>
          )}
          {!gameLoadingError ? (
            <div className="GameLoading__progress-container">
              <div
                className="GameLoading__progress"
                style={{ width: percentLoaded + '%' }}
              />
            </div>
          ) : null}
          <div className="GameLoading__message">{getLoadingMessage()}</div>
          {gameLoadingError && !showAppLinks && (
            <Button
              label={
                <ConnectedFormattedMessage id="game_loading.reload_button_label" />
              }
              clickHandler={handleReload}
              buttonType="secondary-mono"
              blurOnClick={true}
              additionalClasses=" GameLoading__button"
              ctaIcon="reload"
              ctaIconBefore={true}
            />
          )}
        </div>
      );
    } else {
      return null;
    }
  }
}

export default GameLoading;
